const React = require('react');
const formatTime = require("mn-utils/formatTime");
const viewport$ = require('mn-utils/browser/emitters/viewport');
const withReDelay = require('mn-utils/withReDelay');
const {paramStore} = require('../../../../../stores');
const Caption = require('../../../../dumb/Caption/C');
const IntervalFilter = require('../../../../dumb/IntervalFilter');
const ColC = require('../../../../dumb/Col/C');
const ReportDownload = require("../../../../dumb/ReportDownload/B");
const UpdateA = require("../../../../dumb/Button/UpdateA");

const TableRow = require('./TableRow');

const {
  INTERVAL_YEAR,
  getDateRange,
} = IntervalFilter;

const filter$ = paramStore('filter', {
  interval: INTERVAL_YEAR,
});

module.exports = require('../../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
    viewport: viewport$.throttle(100),
  },
  rowHeight: 112,
  request: require('../../../../../api/merchant/invoiceHistory').apiV2InvoiceList,
  requestWrapper(self, request, params) {
    // console.log(request);
    // return isUserAccessed(PERMISSION_PAYOUT_HISTORY)
    //   ? request(params)
    //   : null;
    return request(params);
  },
  getParams: (self) => {
    const filter = self.state.filter;
    const {
      from,
      to,
    } = getDateRange(filter);

    const dateMask = '{yyyy}-{mm}-{dd}';

    return {
      search: filter.search || null,
      from: from && formatTime(from, dateMask),
      to: to && formatTime(to, dateMask),
      // from: from ? getRFC3339(from) : null,
      // to: to ? getRFC3339(to) : null,
    };
  },
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 1000);
    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    return (state) => {
      const filter = state.filter;
      const noData = !state.data || !state.data.count;

      // isUserAccessed(PERMISSION_DASHBOARD) || replaceLocationLazy({
      //   path: LINK_TRANSACTIONS,
      // });

      return (
        <>
          <div className="layoutRow jcSB aiC">
            <Caption>Invoice history</Caption>
            <div className="layoutRow">
              <UpdateA
                className="pl10"
                name="Update table"
                onClick={self.update}
              />
              <ReportDownload
                className="pl10"
                urlPrefix="/f2c/v1/console/invoices/"
                filter={getDateRange(filter)}
                disabled={noData}
            />
            </div>
          </div>
          <div className="layoutRow jcSB aiC mt32">
            <IntervalFilter
              data={filter}
              onChange={handleChangeFilter}
              disabledSearch
              disabledTransactionType
              disabledStatus
            />
            {/*<div className="pb20 dN@m">*/}
            {/*  <DownloadA*/}
            {/*    onClick={() => console.log('Start download')}*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
          <div className="mt15 rlv hmin493">
            <div className="h abs sh st0 ov">
              <div className="abs s ov ovxA">
                <div className="wmin600 h rlv">
                  <div className="bgE layoutRow fhaC fvaC r9 ov ph20 w1/5>1">
                    <ColC>Number</ColC>
                    <ColC>Amount</ColC>
                    <ColC>TRX Volume</ColC>
                    <ColC>Date</ColC>
                    <ColC>Status</ColC>
                  </div>
                  <div className="abs sh st45 sb ovH c0>.CircularProgress">
                    {render(TableRow)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    };
  },
});
